// extracted by mini-css-extract-plugin
export default {"sidebar":"ConfigurationSidebar_sidebar__uRm-l","sidebar__wrapper":"ConfigurationSidebar_sidebar__wrapper__jnzWA","sidebar__support":"ConfigurationSidebar_sidebar__support__CGr9f"};